/**
 * Chat API Client
 */
import apiClient from "./client";

import { ChatMessage, ChatSession, ChatHistory } from "../types/chat.types";
export interface SendMessageRequest {
  content: string;
  session_id?: string;
  llm_provider?: string;
  llm_model?: string;
}
export interface SendMessageResponse {
  id: string;
  session_id: string;
  role: string;
  content: string;
  metadata?: any;
  created_at: string;
}
export interface UploadFileInChatRequest {
  session_id: string;
  file: File;
  job_type?: string;
}
export interface ChatSessionListResponse {
  total: number;
  sessions: ChatSession[];
}
const chatApi = {
  /**
   * Send a message in chat
   */
  sendMessage: async (data: SendMessageRequest): Promise<ChatMessage> => {
    const response = await apiClient.post<SendMessageResponse>(
      "/chat/message",
      data
    );
    return response.data as ChatMessage;
  },

  /**
   * Upload file in chat context
   */
  uploadFile: async (data: UploadFileInChatRequest): Promise<any> => {
    const formData = new FormData();
    formData.append("session_id", data.session_id);
    formData.append("file", data.file);
    if (data.job_type) {
      formData.append("job_type", data.job_type);
    }
    const response = await apiClient.post("/chat/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  /**
   * Get user's chat sessions
   */
  getSessions: async (
    page: number = 1,
    page_size: number = 20
  ): Promise<ChatSessionListResponse> => {
    const response = await apiClient.get<ChatSessionListResponse>(
      "/chat/sessions",
      {
        params: { page, page_size },
      }
    );
    return response.data;
  },

  /**
   * Get chat history for a session
   */
  getHistory: async (session_id: string): Promise<ChatHistory> => {
    const response = await apiClient.get<ChatHistory>(
      `/chat/history/${session_id}`
    );
    return response.data;
  },

  /**
   * Delete a chat session
   */
  deleteSession: async (session_id: string): Promise<void> => {
    await apiClient.delete(`/chat/sessions/${session_id}`);
  },

  /**
   * Close/end a chat session (makes it read-only)
   */
  closeSession: async (session_id: string): Promise<{ message: string; session_id: string }> => {
    const response = await apiClient.patch(`/chat/sessions/${session_id}/close`);
    return response.data;
  },
};

export default chatApi;
